// extracted by mini-css-extract-plugin
export default {"shareTestContainer":"uuaohJNAtLP7NcqXaVip","success":"dLW22TtujAPVL30e5dN3"};